





























































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Select from '@/components/Select.vue'
import Input from '@/components/inputs/Input.vue'
import MultiSelectWrapped from '@/components/inputs/MultiSelectWrapped.vue'
import TimeCard from './components/TimeCard.vue'
import Switcher from '@/components/Switcher.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import ScrollView from '@/components/ScrollView.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import {
  EPaymentEmailSettings,
  ESortOrder,
  EUserPermissions,
  EUserType,
  IChain,
  IFacility,
  IUser,
  IUserChainRole,
  IUserCustomPermission,
  IUserDTO,
  IUserRolePermission
} from '@zunta/configurations'
import { PermissionsModule } from '@/store/modules/permissions.module'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import { PHONE_MASK, TIMEZOMES_LIST, USER_PERMISSIONS_LIST } from '@/constants'
import {
  ETableColumnType,
  EUserPermissionsCategory,
  ISelectItem,
  ITableConfig,
  ITimeZoneListItem,
  IUserPermissionItem
} from '@/interfaces'
import { validateEmail } from '@/utils/helpers'

import { NoCache } from '@/decorators/NoCache'
import Api from '@/api'
import { User } from '@/classes/User'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import EditYourselfPopup from '@/views/app/management/users/components/EditYourselfPopup.vue'

interface ICustomPermissionsFilter {
  name: string;
  category: string;
  description: string;
}

const defaultUserData: IUserDTO = {
  lastName: '',
  firstName: '',
  email: '',
  phone: '',
  phoneExtension: '',
  type: EUserType.CLIENT,
  isCustomPermissions: false,
  timezone: 0,
  title: '',
  facilities: [],
  isAllFacilities: false,
  permissions: [],
  receiveManagerEmail: false,
  includePaymentsProcessedUser: false,
  includePaymentsProcessedManager: false,
  managerEmailFacilities: [],
  paymentEmailSetting: EPaymentEmailSettings.NEVER,
  depositEmail: false,
  managerEmailUsers: []
}

@Component({
  components: {
    EditYourselfPopup,
    Table,
    Card,
    SearchInput,
    Checkbox,
    Switcher,
    Select,
    Input,
    TimeCard,
    ScrollView,
    ErrorMessages,
    MultiSelectWrapped
  }
})
export default class ManagementUserEdit extends Vue {
  isEditYourselfConfirmed: boolean = false
  PHONE_MASK = PHONE_MASK
  filters: ICustomPermissionsFilter = {
    name: '',
    category: '',
    description: ''
  }
  user: User = Api.getUser() as User
  selectedTimezone: string | null = null
  userData: IUserDTO = {
    lastName: '',
    firstName: '',
    email: '',
    phone: '',
    phoneExtension: '',
    type: EUserType.CLIENT,
    isCustomPermissions: false,
    timezone: 0,
    facilities: [],
    isAllFacilities: false,
    permissions: [],
    receiveManagerEmail: false,
    includePaymentsProcessedUser: false,
    includePaymentsProcessedManager: false,
    managerEmailFacilities: [],
    paymentEmailSetting: EPaymentEmailSettings.NEVER,
    depositEmail: false,
    managerEmailUsers: []
  }
  errors: any = {}
  // checkingAnyFieldEditedInterval: any;

  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  prevUserId: string | null = null
  facilitiesFilter: string = ''
  facilitiesFilter2: string = ''

  EPaymentEmailSettings: any = EPaymentEmailSettings

  userSearch: string = ''
  isLoading: string = ''

  selectedFacilities: ISelectItem[] = []
  selectedManagerEmailFacilities: ISelectItem[] = []
  selectedEmailUsers: ISelectItem[] = []

  get config (): ITableConfig {
    return {
      fetchFunction: this.setCustomPermissionFilter,
      maxHeight: '400px',
      debounceTime: 10,
      columns: [
        {
          minWidth: '100px',
          width: 20,
          key: 'name',
          searchKey: 'name',
          hasSearch: true,
          label: 'Permission',
          type: ETableColumnType.default
        },
        {
          minWidth: '100px',
          width: 20,
          key: 'category',
          searchKey: 'category',
          hasSearch: true,
          label: 'Category',
          type: ETableColumnType.select,
          options: this.customPermissionCategoryFilterItems
        },
        {
          minWidth: '100px',
          width: 55,
          key: 'description',
          searchKey: 'description',
          hasSearch: true,
          label: 'Description',
          type: ETableColumnType.default
        },
        {
          minWidth: '100px',
          class: 'text-center',
          width: 5,
          key: 'actions',
          type: ETableColumnType.actions
        }
      ]
    }
  }

  getFacilityName (facility: IFacility) {
    return facility.shortName && facility.shortName.trim().length
      ? facility.shortName
      : facility.name
  }

  get chainId () {
    return this.$route.query.chain
  }

  get userChainId () {
    return this.$route.query.userChainId
  }

  @NoCache
  get userId () {
    return this.$route.params.id
  }

  get userList () {
    return this.$store.state.user.users
  }

  get adminUserList () {
    return this.$store.state.user.adminUsers
  }

  get adminUsersListItems () {
    return this.adminUserList.map((user: IUser) => {
      return {
        value: user.id,
        content: `${user.firstName} ${user.lastName}`,
        key: user.id
      }
    })
  }

  get filteredUserList () {
    // const notSelected = this.userList.filter((user: IUser) => !(this.userData.managerEmailUsers as any[]).includes(user.id))
    // const chainUsers = notSelected.filter((user: IUser) => {
    //   return !!user.chain && (((user.chain as IChain).id || user.chain) === +(this.userChainId || this.chainId))
    // })
    const chainUsers = this.userList
    if (!this.userSearch) {
      return this.setOptionsList(chainUsers, this.setUserLabel)
    }
    const nameParts = this.userSearch.replace(/#/gm, '').split(' ')
    const users = chainUsers.filter((user: IUser) => {
      if (nameParts.length > 1) {
        return (user.firstName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
            (user.lastName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
            (user.firstName.toLowerCase()).startsWith(nameParts[1].toLowerCase()) ||
            (user.lastName.toLowerCase()).startsWith(nameParts[1].toLowerCase())
      }
      return (user.firstName.toLowerCase()).startsWith(nameParts[0].toLowerCase()) ||
          (user.lastName.toLowerCase()).startsWith(nameParts[0].toLowerCase())
    })

    return this.setOptionsList(users, this.setUserLabel)
  }

  get isNew () {
    return this.userId === 'new'
  }

  get selectedUser () {
    return this.$store.state.user.selectedUser
  }

  get facilitiesList () {
    return this.$store.state.facility.facilities
  }

  setFacilitiesFilter (value: string) {
    this.facilitiesFilter = value.toLowerCase()
  }

  setFacilitiesFilter2 (value: string) {
    this.facilitiesFilter2 = value.toLowerCase()
  }

  get facilitiesFilteredList () {
    if (this.facilitiesFilter !== '') {
      const list = this.facilitiesList.filter((facility: IFacility) => facility.name.toLowerCase().includes(this.facilitiesFilter))
      return this.setOptionsList(list, this.getFacilityName)
    }
    return this.setOptionsList(this.facilitiesList, this.getFacilityName)
  }

  get facilitiesFilteredList2 () {
    if (this.facilitiesFilter2 !== '') {
      const list = this.facilitiesList.filter((facility: IFacility) => facility.name.toLowerCase().includes(this.facilitiesFilter2))
      return this.setOptionsList(list, this.getFacilityName)
    }
    return this.setOptionsList(this.facilitiesList, this.getFacilityName)
  }

  setOptionsList (array: any, method: any) {
    return array.map((facility: IFacility) => {
      return {
        value: facility.id,
        key: facility.id,
        content: method(facility)
      }
    })
  }

  get userCustomPermissionsList () {
    return this.$store.state.permissions.userCustomPermissions
  }

  get customPermissionCategoryFilterItems () {
    return [{
      content: 'All',
      value: '',
      key: 'all'
    }].concat(Object.values(EUserPermissionsCategory).map((permissionCategory: string) => ({
      content: permissionCategory,
      value: permissionCategory,
      key: permissionCategory
    })))
  }

  get permissionsTotalItemsList () {
    return USER_PERMISSIONS_LIST
  }

  get permissionsItemsList () {
    return this.permissionsTotalItemsList.filter((permissionItem: IUserPermissionItem) => (
        !!this.selectedRolePermissions.find((permission: IUserRolePermission) => (
            permission.permission === permissionItem.permission
        ))
    )).filter((permissionItem: IUserPermissionItem) => {
      const fieldsForRegExpChecking: string[] = ['name', 'category', 'description']
      for (let i = 0; i < fieldsForRegExpChecking.length; i++) {
        const field: string = fieldsForRegExpChecking[i]
        const fieldValue: string = (this.filters as any)[field]
        if (fieldValue) {
          if (!new RegExp(`${fieldValue}`, 'i').test((permissionItem as any)[field])) {
            return false
          }
        }
      }
      return true
    })
  }

  get afternoonBriefingListItems () {
    return [{
      key: '12:00 PM',
      content: '12:00 PM',
      value: 12
    }, {
      key: '12:30 PM',
      content: '12:30 PM',
      value: 12.5
    }, {
      key: '1:00 PM',
      content: '1:00 PM',
      value: 13
    }, {
      key: '1:30 PM',
      content: '1:30 PM',
      value: 13.5
    }, {
      key: '2:00 PM',
      content: '2:00 PM',
      value: 14
    }, {
      key: '2:30 PM',
      content: '2:30 PM',
      value: 14.5
    }, {
      key: '3:00 PM',
      content: '3:00 PM',
      value: 15
    }, {
      key: '3:30 PM',
      content: '3:30 PM',
      value: 15.5
    }, {
      key: 'donotsend',
      content: 'Do Not Send',
      value: undefined
    }]
  }

  get eveningBriefingListItems () {
    return [{
      key: '5:00 PM',
      content: '5:00 PM',
      value: 17
    }, {
      key: '5:30 PM',
      content: '5:30 PM',
      value: 17.5
    }, {
      key: '6:00 PM',
      content: '6:00 PM',
      value: 18
    }, {
      key: '6:30 PM',
      content: '6:30 PM',
      value: 18.5
    }, {
      key: '7:00 PM',
      content: '7:00 PM',
      value: 19
    }, {
      key: '7:30 PM',
      content: '7:30 PM',
      value: 19.5
    }, {
      key: 'donotsend',
      content: 'Do Not Send',
      value: undefined
    }]
  }

  get morningBriefingListItems () {
    return [{
      key: '5:00 AM',
      content: '5:00 AM',
      value: 5
    }, {
      key: '5:30 AM',
      content: '5:30 AM',
      value: 5.5
    }, {
      key: '6:00 AM',
      content: '6:00 AM',
      value: 6
    }, {
      key: '6:30 AM',
      content: '6:30 AM',
      value: 6.5
    }, {
      key: '7:00 AM',
      content: '7:00 AM',
      value: 7
    }, {
      key: '7:30 AM',
      content: '7:30 AM',
      value: 7.5
    }, {
      key: '8:00 AM',
      content: '8:00 AM',
      value: 8
    }, {
      key: '8:30 AM',
      content: '8:30 AM',
      value: 8.5
    }, {
      key: '9:00 AM',
      content: '9:00 AM',
      value: 9
    }, {
      key: '9:30 AM',
      content: '9:30 AM',
      value: 9.5
    }, {
      key: '10:00 AM',
      content: '10:00 AM',
      value: 10
    }, {
      key: 'donotsend',
      content: 'Do Not Send',
      value: undefined
    }]
  }

  get userRoles () {
    return this.$store.state.permissions.roles
  }

  get rolesItemsList () {
    return this.userRoles.map((role: IUserChainRole) => ({
      content: role.name,
      key: role.id,
      value: role.id
    }))
  }

  get permissionsList () {
    return this.$store.state.permissions.permissions
  }

  @NoCache
  get selectedRolePermissions () {
    return this.permissionsList.filter((permission: IUserRolePermission) => (
        permission.role === this.userData.role
    ))
  }

  get timezoneItemList () {
    return TIMEZOMES_LIST.map((timezoneListItem: ITimeZoneListItem) => ({
      key: timezoneListItem.shortName,
      value: timezoneListItem.shortName,
      content: timezoneListItem.name
    }))
  }

  get rolesItemList () {
    return this.userRoles.map((userRole: IUserChainRole) => ({
      key: userRole.id,
      value: userRole.id,
      content: userRole.name
    }))
  }

  setUserLabel (user: IUser | number) {
    if (typeof user === 'number') {
      const us = this.userList.find((item: IUser) => user === item.id)
      if (!us) {
        return 'Not Found'
      }
      return `${us.firstName ? us.firstName : ''} ${us.lastName ? us.lastName : ''}`
    }
    return `${user.firstName ? user.firstName : ''} ${user.lastName ? user.lastName : ''}`
  }

  async mounted () {
    await this.initUserData()
    // this.checkingAnyFieldEditedInterval = setInterval(() => {
    //   if (this.isNew) {
    //     if (JSON.stringify(this.userData) !== JSON.stringify(defaultUserData)) {
    //       FormCompletionManager.markEdited('user-form')
    //     } else {
    //       FormCompletionManager.markCompleted('user-form')
    //     }
    //   }
    //   else {
    //     const getProps = (data: any, propsNames: string[]) => {
    //       const propsData: any = {}
    //       const getPropValue = (data: any, propName: string) => {
    //         const props: string[] = propName.split('.')
    //         let currentValue: any = data
    //         props.forEach((prop: string) => {
    //           currentValue = currentValue[prop]
    //         })
    //         return currentValue
    //       }
    //       const checkPropsNames: string[] = propsNames.map((propName: string) => propName.split('.')[0])
    //       Object.keys(data).sort((a: string, b: string) => checkPropsNames.indexOf(a) - checkPropsNames.indexOf(b)).forEach((propName: string) => {
    //         const index = checkPropsNames.indexOf(propName)
    //         if (index !== -1) {
    //           const value: any = getPropValue(data, propsNames[index])
    //           const propValue = value !== null && value !== undefined && typeof value === 'object' ? JSON.stringify(value) : value ? value.toString() : ''
    //           if (propValue) {
    //             propsData[propName] = propValue
    //           }
    //         }
    //       })
    //       return propsData
    //     }
    //     if (JSON.stringify(getProps({
    //       ...this.userData,
    //       facilities: (this.userData.facilities || []).map(Number)
    //     }, [
    //       'firstName',
    //       'lastName',
    //       'timezone',
    //       'email',
    //       'isAllFacilities',
    //       'facilities',
    //       'isCustomPermissions',
    //       'phone',
    //       'phoneExtension',
    //       'permissions',
    //       'role',
    //       'morningBriefing',
    //       'afternoonBriefing',
    //       'eveningBriefing',
    //       'depositEmail'
    //     ])) !== JSON.stringify(getProps({
    //       ...this.selectedUser,
    //       facilities: this.selectedUser.facilities.map(Number),
    //       permissions: this.userCustomPermissionsList.map((customPermission: IUserCustomPermission) => (
    //         customPermission.permission
    //       ))
    //     }, [
    //       'firstName',
    //       'lastName',
    //       'timezone',
    //       'email',
    //       'isAllFacilities',
    //       'facilities',
    //       'isCustomPermissions',
    //       'phone',
    //       'phoneExtension',
    //       'permissions',
    //       'role.id',
    //       'morningBriefing',
    //       'afternoonBriefing',
    //       'eveningBriefing',
    //       'depositEmail'
    //     ]))) {
    //       FormCompletionManager.markEdited('user-form')
    //     } else {
    //       FormCompletionManager.markCompleted('user-form')
    //     }
    //   }
    // }, 100)
  }

  removeFromUsersInDailyEmail (user: number) {
    this.userData.managerEmailUsers = (this.userData.managerEmailUsers as any[]).filter((item: number) => item !== user)
  }

  addToUsersInDailyEmail (user: IUser) {
    (this.userData.managerEmailUsers as any[]).push(user.id)
  }

  async updated () {
    if (this.prevUserId !== this.userId) {
      await this.initUserData()
      this.$forceUpdate()
    }
  }

  beforeDestroy () {
    this.permissionsModuleInstance.resetUserCustomPermission()
    this.userModuleInstance.resetSelectedUser()
  }

  noAnyBriefingSelected () {
    return !!this.errors.briefings
  }

  async initUserData () {
    this.prevUserId = this.userId
    if (!this.isNew) {
      await this.userModuleInstance.fetchUserById(this.userId)
    }
    const asyncActions = [
      this.userModuleInstance.getManagementUsersList({ chain: this.chainId }),
      this.userModuleInstance.getOnlyAdminUsersList({ chain: this.chainId }), // This one is conflicting with getManagementUsersList --> commented for now
      this.facilityModuleInstance.getFacilityList({ chain: +(this.chainId || this.userChainId), sortBy: 'name', sortOrder: ESortOrder.ASC }),
      this.permissionsModuleInstance.getUserRoles(this.isNew ? undefined : (this.selectedUser.chain as IChain).id),
      this.permissionsModuleInstance.getPermissions(this.isNew ? undefined : (this.selectedUser.chain as IChain).id)
    ]
    if (!this.isNew) {
      asyncActions.push(this.permissionsModuleInstance.getUserCustomPermissions(this.userId))
    }
    await Promise.all(asyncActions)
    this.userData = JSON.parse(JSON.stringify(defaultUserData))
    this.selectedTimezone = null
    if (!this.isNew && this.selectedUser) {
      this.userData.firstName = this.selectedUser.firstName
      this.userData.lastName = this.selectedUser.lastName
      this.userData.timezone = this.selectedUser.timezone
      this.userData.email = this.selectedUser.email
      this.userData.title = this.selectedUser.title
      this.userData.adminUser = this.selectedUser.adminUser
      this.userData.isAllFacilities = this.selectedUser.isAllFacilities
      this.userData.depositEmail = this.selectedUser.depositEmail
      this.userData.facilities = this.selectedUser.facilities.map(Number)
      this.userData.isCustomPermissions = this.selectedUser.isCustomPermissions
      this.userData.phone = this.selectedUser.phone
      this.userData.phoneExtension = this.selectedUser.phoneExtension
      this.userData.permissions = this.userCustomPermissionsList.map((customPermission: IUserCustomPermission) => (
          customPermission.permission
      ))
      // this.userData.isChainAdmin = this.selectedUser.isChainAdmin
      // if (this.selectedUser.role) {
      //   this.userData.role = typeof this.selectedUser.role === 'number' ? this.selectedUser.role : this.selectedUser.role.id
      // }
      if (this.selectedUser.role) {
        this.userData.role = this.selectedUser.role.id
      }
      if (this.selectedUser.morningBriefing) {
        this.userData.morningBriefing = parseFloat(this.selectedUser.morningBriefing)
      }
      if (this.selectedUser.afternoonBriefing) {
        this.userData.afternoonBriefing = parseFloat(this.selectedUser.afternoonBriefing)
      }
      if (this.selectedUser.eveningBriefing) {
        this.userData.eveningBriefing = parseFloat(this.selectedUser.eveningBriefing)
      }

      this.userData.receiveManagerEmail = this.selectedUser.receiveManagerEmail
      this.userData.includePaymentsProcessedUser = this.selectedUser.includePaymentsProcessedUser
      this.userData.includePaymentsProcessedManager = this.selectedUser.includePaymentsProcessedManager
      this.userData.managerEmailFacilities = this.selectedUser.managerEmailFacilities ? this.selectedUser.managerEmailFacilities
          .map(($facility: any) => (Number($facility))) : []
      this.userData.paymentEmailSetting = this.selectedUser.paymentEmailSetting
      this.userData.managerEmailFacilitiesAll = this.selectedUser.managerEmailFacilitiesAll
      this.userData.managerEmailUsers = this.selectedUser.managerEmailUsers ? this.selectedUser.managerEmailUsers.map(Number) : []

      const selectedTimezoneItem: ITimeZoneListItem | undefined = TIMEZOMES_LIST.find((timezoneListItem: ITimeZoneListItem) => (
          timezoneListItem.timezone === this.userData.timezone
      ))
      if (selectedTimezoneItem) {
        this.selectedTimezone = selectedTimezoneItem.shortName
      }
    }
    this.selectedFacilities = this.setSelectedObjectsArray(this.facilitiesFilteredList2, this.userData.facilities as Array<Number>)
    this.selectedManagerEmailFacilities = this.setSelectedObjectsArray(this.facilitiesFilteredList, this.userData.managerEmailFacilities as Array<Number>)
    this.selectedEmailUsers = this.setSelectedObjectsArray(this.filteredUserList, this.userData.managerEmailUsers as Array<Number>)
  }

  setSelectedObjectsArray (optionArray: ISelectItem[], numberArray: Array<Number>) {
    return optionArray.filter((el: ISelectItem) => numberArray.includes(el.value))
  }

  isPermissionChecked (permissionItem: IUserPermissionItem) {
    if (!this.userData.permissions) return false
    return !!this.userData.permissions.find((permission: EUserPermissions) => (
        permission === permissionItem.permission
    ))
  }

  isInAvailablePermissionsList (permissionItem: IUserPermissionItem) {
    return !!this.selectedRolePermissions.find((selectedRolePermission: IUserRolePermission) => (
        selectedRolePermission.permission === permissionItem.permission
    ))
  }

  isAllPermissionsChecked () {
    return this.userData.permissions &&
        this.userData.permissions.length === this.selectedRolePermissions.length
  }

  validate () {
    this.errors = {}
    if (!this.userData.firstName) {
      this.errors.firstName = 'First Name is required'
    }
    if (!this.userData.lastName) {
      this.errors.lastName = 'Last Name is required'
    }
    if (!this.userData.isAllFacilities &&
        (
            !this.userData.facilities ||
            this.userData.facilities.length === 0
        )
    ) {
      this.errors.facility = 'You Must choose some facilities'
    }
    if (!this.userData.timezone) {
      this.errors.timezone = 'Timezone is required'
    }
    if (
        this.userData.isCustomPermissions &&
        (
            !this.userData.permissions ||
            this.userData.permissions.length === 0
        )
    ) {
      this.errors.permissions = 'You must select some permissions'
    }
    if (!this.userData.role && !this.userData.isCustomPermissions) {
      this.errors.role = 'You must select role'
    }
    if (!this.userData.phone) {
      this.errors.phone = 'Phone is required'
    }
    if (!validateEmail(this.userData.email)) {
      this.errors.email = 'You must enter valid email address'
    }
    // if (!this.userData.eveningBriefing && !this.userData.morningBriefing && !this.userData.afternoonBriefing) {
    //   this.errors.briefings = 'You must select at least one daily briefing'
    // }
    return Object.keys(this.errors).length === 0
  }

  async save () {
    if (this.user.data.type !== 'ZUNTA' && !this.user.hasPermissionFor(EUserPermissions.MODIFY_USERS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Modify Users',
        message: 'Permission Denied',
        icon: 'warning'
      })
      return
    }

    const validationResult = this.validate()
    this.$forceUpdate()
    this.$eventBus.$emit('Input:validate')
    this.$eventBus.$emit('Select:validate')

    if (!validationResult) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    if (validationResult) {
      let res
      let error
      let header
      let message
      if (this.isNew) {
        res = await this.userModuleInstance.createUser({
          data: {
            ...this.userData,
            isChainAdmin: false
          },
          type: 'management'
        })
        header = `Create User`
        if (res.error) {
          console.log('error', res)
          error = res.error
          header = `Can't Create User`
          message = res.message ? res.message : `User wasn't created`
        } else {
          header = `Create User`
          message = `User was successfully created`
        }
      } else {
        error = await this.userModuleInstance.updateUser({
          id: this.selectedUser.id,
          data: {
            ...this.userData
          },
          type: 'management'
        })
        header = `Update User`
        if (error) {
          message = `User wasn't updated`
        } else {
          message = `User was successfully updated`
        }
      }
      // clearInterval(this.checkingAnyFieldEditedInterval)
      // FormCompletionManager.markCompleted('user-form')
      if (!error) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          header,
          message,
          icon: 'check'
        })
        this.goBack()
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          header,
          message,
          icon: 'warning'
        })
      }
    }

    this.isEditYourselfConfirmed = false
  }

  selectUserRole (item: ISelectItem) {
    this.userData.role = item.value
    if (this.userData.isCustomPermissions) {
      this.toggleAllPermissions(true)
    }
    this.$forceUpdate()
  }

  selectAdminUser (item: ISelectItem) {
    this.userData.adminUser = item.value
    this.$forceUpdate()
  }

  addCustomizePermissions () {
    this.userData.isCustomPermissions = true
    this.toggleAllPermissions(true)
    this.$forceUpdate()
  }

  removeCustomPermissions () {
    this.userData.isCustomPermissions = false
    this.userData.permissions = []
  }

  selectTimezone (item: ISelectItem) {
    const selected: ITimeZoneListItem | undefined = TIMEZOMES_LIST.find((timezoneListItem: ITimeZoneListItem) => (
        timezoneListItem.shortName === item.value
    ))
    if (selected) {
      this.userData.timezone = selected.timezone
      this.selectedTimezone = item.value
      this.$forceUpdate()
    }
  }

  selectBriefing (type: string, item: ISelectItem) {
    (this.userData as any)[type] = item.value
    this.$forceUpdate()
  }

  toggleAllFacilitiesAccess (active: boolean) {
    this.userData.isAllFacilities = active
    this.userData.facilities = []
    this.$forceUpdate()
  }

  toggleAllPermissions (isAll: boolean) {
    if (isAll) {
      this.userData.permissions = this.selectedRolePermissions.map((permission: IUserRolePermission) => permission.permission)
    } else {
      this.userData.permissions = []
    }
    this.$forceUpdate()
  }

  isFacilitySelected (facilityId: number) {
    return this.userData.facilities && this.userData.facilities.includes(facilityId)
  }

  isFacilitySelectedForMailingSettings (facilityId: number) {
    // @ts-ignore
    return this.userData.managerEmailFacilities && this.userData.managerEmailFacilities
        .map(($facility: any) => Number($facility)).includes(Number(facilityId))
  }

  changeFacilitySelect (facilityId: number, selected: any) {
    if (this.userData.facilities) {
      if (selected.target.checked) {
        if (!this.isFacilitySelected(facilityId)) {
          this.userData.facilities.push(facilityId)
        }
      } else {
        this.userData.facilities = this.userData.facilities.filter((existsFacilityId: number) => (
            existsFacilityId !== facilityId
        ))
      }
    }
    this.$forceUpdate()
  }

  setSelectedFacilities (facilities: ISelectItem[]) {
    if (facilities.length) this.userData.facilities = facilities.map((el: ISelectItem) => el.value)
    else this.userData.facilities = []
  }

  setSelectedEmailFacilities (items: ISelectItem[]) {
    if (items.length) this.userData.managerEmailFacilities = items.map((el: ISelectItem) => el.value)
    else this.userData.managerEmailFacilities = []
  }

  setSelectedEmailManagers (items: ISelectItem[]) {
    if (items.length) this.userData.managerEmailUsers = items.map((el: ISelectItem) => el.value)
    else this.userData.managerEmailUsers = []
  }

  toggleAllFacilitiesForMailingSettings (event: any) {
    this.userData.managerEmailFacilities = []
    this.userData.managerEmailFacilitiesAll = event
    this.$forceUpdate()
  }

  changeFacilitySelectForMailingSettings (facilityId: number, selected: any) {
    if (this.userData.facilities) {
      if (selected.target.checked) {
        if (!this.isFacilitySelectedForMailingSettings(facilityId)) {
          // @ts-ignore
          this.userData.managerEmailFacilities.push(facilityId)
        }
      } else {
        // @ts-ignore
        this.userData.managerEmailFacilities = this.userData.managerEmailFacilities.filter((existsFacilityId: number) => (
            existsFacilityId !== facilityId
        ))
      }
    }
    this.$forceUpdate()
  }

  togglePermissionSelect (permissionItem: IUserPermissionItem, selected: boolean) {
    if (this.userData.permissions) {
      if (selected) {
        if (!this.isPermissionChecked(permissionItem)) {
          this.userData.permissions.push(permissionItem.permission)
        }
      } else {
        this.userData.permissions = this.userData.permissions.filter((permission: string) => (
            permission !== permissionItem.permission
        ))
      }
    }
  }

  toggleMailingSettings (key: any, value: any): void {
    // @ts-ignore
    this.userData[key] = value
  }

  setCustomPermissionFilter (filters: ICustomPermissionsFilter) {
    this.filters = filters
  }

  goBack () {
    this.$locationManager.goBack({ name: 'management-users' })
  }
}
